import get from 'lodash/get';

import {
  BUILDING_UNITS_SUCCESS,
  GET_UNITS_WITH_CONTACTS_SUCCESS,
  GET_UNIT_SUCCESS,
  UNIT_REMOVE_SUCCEEDED,
  UNIT_RESIDENTS_REQUESTED,
} from '../actionConstants';

import { arrayToObject, removeByKey } from './utils';

const defaultState = {};

export default (state = defaultState, action) => {
  let newState;
  switch (action.type) {
    case UNIT_REMOVE_SUCCEEDED:
      newState = removeByKey(state, action.unitId);
      return newState;
    case BUILDING_UNITS_SUCCESS: {
      const units =
        get(action, 'res.data.data', null) || get(action, 'res.data', []);
      return {
        ...arrayToObject(units),
      };
    }
    case GET_UNIT_SUCCESS: {
      return {
        ...state,
        [action?.res?.data?.id]: action?.res?.data,
      };
    }
    case GET_UNITS_WITH_CONTACTS_SUCCESS: {
      return {
        ...arrayToObject(action.res.data),
      };
    }
    case UNIT_RESIDENTS_REQUESTED: {
      return {
        ...state,
        [action.unitId]: {
          ...state[action.unitId],
          residents: get(action, 'payload.data', []),
        },
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
